import React from "react";
import type { ModalViewType } from "../../../../../common-deprecated/types/CommonTypes";
import type { MODAL_USC_DISCOVER_YOUR_CAR } from "../../../utils/modalConstants";
import { UscLabel } from "../../../utils/labels";
import useMenuSectionSelectors, { scrollSelectorSectionMap } from "../../../hooks/useMenuSectionSelectors";
import * as Styles from "../pdp/common/HorizontalMenu.styles";
import ModalBaseView from "../styles/organisms/Modal";
import * as ModalStyles from "../styles/organisms/Modal.styles";
import Button from "../styles/atoms/Button";
import Text from "../styles/atoms/Text";
import Navigation from "../styles/atoms/Navigation";
import Icon from "../styles/Icon";
import { trackDiscoverYourCarModalClose, trackDiscoverYourCarModalSelect } from "../../../utils/tracking";
import { useUscSelector } from "../../../redux/store";

export type UscDiscoverYourCarType = {
    type: typeof MODAL_USC_DISCOVER_YOUR_CAR;
};

const DiscoverYourCarModal = (props: ModalViewType<UscDiscoverYourCarType>): JSX.Element => {
    const { show, close, modalSettings } = props;
    const vehicleType = useUscSelector((state) => state.vehicle.type);

    const { selectors, scrollSelectorsLabelMap, scrollTo } = useMenuSectionSelectors(
        Styles.HORIZONTAL_MENU_HEIGHT,
        Styles.BREADCRUMBS_HEIGHT,
        Styles.EXTRA_DETECTION_MARGIN,
        Styles.ARROW_WIDTH,
        Styles.EXTRA_SCROLL_MARGIN,
    );

    return (
        <ModalBaseView modalIdType={modalSettings.type} onClose={close} show={show} size="fullwidthautoheight">
            <ModalStyles.Header bgColour="silver">
                <Text tag="h2" variant="paragraph-body-regular" color="midnight">
                    <UscLabel label="uscDiscoverYourCar" />
                </Text>
                <Button
                    variant="control"
                    onClick={() => {
                        trackDiscoverYourCarModalClose(vehicleType);
                        close();
                    }}
                    size="small"
                >
                    <Icon variant="close" />
                </Button>
            </ModalStyles.Header>
            <ModalStyles.Body noSpacing>
                <Navigation variant="product-specs">
                    <ul>
                        {selectors.map((selector) => {
                            const section = scrollSelectorSectionMap[selector];

                            return (
                                <li key={section}>
                                    <a
                                        href={`#${selector}`}
                                        type="button"
                                        onClick={(event) => {
                                            event.preventDefault();
                                            trackDiscoverYourCarModalSelect(vehicleType, section);
                                            requestAnimationFrame(() => scrollTo(selector));
                                            close();
                                        }}
                                        aria-label={selector}
                                    >
                                        <UscLabel label={scrollSelectorsLabelMap[selector]} />
                                        <Icon variant="chevron-right" />
                                    </a>
                                </li>
                            );
                        })}
                    </ul>
                </Navigation>
            </ModalStyles.Body>
        </ModalBaseView>
    );
};

export default DiscoverYourCarModal;
